import { fmtDateTime } from "@/lib/format";
import { Pill } from "./kit";

export const ActivityList = ({ items }) =>
  items?.length ? (
    <ol className="space-y-3 max-h-[420px] overflow-auto pr-2" data-testid="activity-list">
      {items.map((a) => (
        <li key={a.id} className="border-l border-[#27272A] pl-4 relative">
          <span className="absolute -left-[3px] top-1.5 w-1.5 h-1.5 bg-[#0055FF]" />
          <p className="text-sm text-zinc-200">{a.detail || a.action}</p>
          <p className="text-xs text-zinc-600">{a.by} · {fmtDateTime(a.at)}</p>
        </li>
      ))}
    </ol>
  ) : <p className="text-sm text-zinc-600">No activity yet.</p>;

export const NotificationList = ({ items, onRetry }) =>
  items?.length ? (
    <ul className="divide-y divide-[#27272A]" data-testid="notification-list">
      {items.map((n) => (
        <li key={n.id} className="py-2.5 flex items-start justify-between gap-3 text-sm">
          <div className="min-w-0">
            <p className="text-zinc-200 truncate">{n.subject || n.template}</p>
            <p className="text-xs text-zinc-600 truncate">To {n.to} · {fmtDateTime(n.created_at)}{n.error ? ` · ${n.error}` : ""}</p>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <Pill status={n.status} />
            {onRetry && n.status === "failed" && <button className="text-xs text-[#00E5FF] underline" onClick={() => onRetry(n.id)} data-testid={`retry-notification-${n.id}`}>Retry</button>}
          </div>
        </li>
      ))}
    </ul>
  ) : <p className="text-sm text-zinc-600">No emails sent yet.</p>;

export const NotesList = ({ notes }) =>
  notes?.length ? (
    <ul className="space-y-3 mb-4" data-testid="notes-list">
      {[...notes].reverse().map((n) => (
        <li key={n.id} className="bg-[#121212] border border-[#27272A] p-3">
          <p className="text-sm text-zinc-200 whitespace-pre-line">{n.text}</p>
          <p className="text-xs text-zinc-600 mt-1">{n.by} · {fmtDateTime(n.at)}</p>
        </li>
      ))}
    </ul>
  ) : null;
